import * as React from 'react';

import styles from './segmentedToggle.module.scss';

type Option<T extends string> = {
  value: T;
  label: string;
};

type SegmentedToggleProps<T extends string> = {
  value: T;
  options: [Option<T>, Option<T>];
  onChange: ( next: T ) => void;
  width?: number;
};

export function SegmentedToggle<T extends string>( {
  value,
  options,
  onChange,
  width = 220
}: SegmentedToggleProps<T> ) {
  const activeIndex = options.findIndex( o => o.value === value );
  const left = activeIndex === 0 ? '2%' : '48%';

  return (
    <div
      role="tablist"
      aria-label="Segmented toggle"
      className={ styles.contianer }
      style={ { width } }
    >
      {/* sliding pill */}
      <div
        aria-hidden="true"
        style={ { left } }
        className={ styles.pill }
      />

      {options.map( ( opt ) => (
        <button
          key={ opt.value }
          type="button"
          role="tab"
          aria-selected={ value === opt.value }
          onClick={ () => onChange( opt.value ) }
          style={ {
            position: 'relative',
            zIndex: 1,
            border: 0,
            background: 'transparent',
            padding: '5px 10px',
            borderRadius: 999,
            cursor: 'pointer',
            opacity: value === opt.value ? 1 : 0.65,
            color: '#0040FF'
          } }
        >
          {opt.label}
        </button>
      ) )}
    </div>
  );
}